// extracted by mini-css-extract-plugin
module.exports = {"addFavorites":"AddFavorites_addFavorites___yskJ","label":"AddFavorites_label__Ntp6t","wrapper":"AddFavorites_wrapper__eT8Tu","icon":"AddFavorites_icon__mqCQi"};